<template>
	<div class="examinationwrap">
		<div class="examination_top">
			<img class="img" src="../../assets/images/xtpt_03.png">
			<div class="tit">{{dataobj.testname}}</div>
			<div class="clone" @click="closeFun">关闭试卷</div>
		</div>
		<div class="timefixd" v-if="djstime"><span>{{djstime}}</span></div>
		<div class="examination_middle"  :style="{'min-height': height+'px'}">
			
			<div class="list" v-if="yyhdata.length > 0">
				<div class="listtits">英译汉</div>
				<div class="con" v-for="(item,index) in yyhdata" :key="index">
					<div class="tit"><span>{{item.WordIndex}})</span><i @click="audioFun(item)" :class="{'on':item.apply_blon}"></i>{{item.word_spell}}</div>
					<ul>
						<li v-for="(items,indexs) in item.HxWord" :key="indexs" @click="choice(item,items)" :class="{'on':(item.choiceg_id == items.gid) || (dataobj.name == 'answer' && items.id > 0),'disabled':(dataobj.name == 'details' || dataobj.name == 'answer' || savetestblon),'error':(savetestblon && (item.choiceg_id == items.gid) && !item.choiceg_blon)}">{{items.word_meaning}}</li>
					</ul>
				</div>
			</div>
			
			<div class="list" v-if="hyydata.length > 0">
				<div class="listtits">汉译英</div>
				<div class="con" v-for="(item,index) in hyydata" :key="index">
					<div class="tit"><span>{{item.WordIndex}})</span>{{item.word_meaning}}</div>
					<ul>
						<li v-for="(items,indexs) in item.HxWord" :key="indexs" @click="choice(item,items)" :class="{'on':(item.choiceg_id == items.gid) || (dataobj.name == 'answer' && items.id > 0),'disabled':(dataobj.name == 'details' || dataobj.name == 'answer' || savetestblon),'error':(savetestblon && (item.choiceg_id == items.gid) && !item.choiceg_blon)}">{{items.word_spell}}</li>
						
					</ul>
				</div>
			</div>
		
			<div class="list" v-if="txdata.length > 0">
				<div class="listtits">听写</div>
				<div class="con" v-for="(item,index) in txdata" :key="index">
					<div class="tit"><span>{{item.WordIndex}})</span><i @click="audioFun(item)" :class="{'on':item.apply_blon}"></i>{{item.word_meaning}}</div>
					<div class="input" :class="{'error':(savetestblon && !item.choiceg_blon),'on':(savetestblon && item.choiceg_blon)}">
						<template v-if="dataobj.name == 'answer'">
							<el-input v-for="(items,indexs) in item.HxWord" :class="{'hide':items.id < 0}" :key="indexs" :disabled="true" placeholder="请输入单词" v-model="items.word_spell"></el-input>
						</template>
						<el-input v-else :disabled="dataobj.name == 'details' || dataobj.name == 'answer' || savetestblon" placeholder="请输入单词" @change="choicetextarea(item)" v-model="item.textarea"></el-input>
					</div>
				</div>
			</div>
				
			<div class="btn_list">
				<div class="btn" @click="savetest">{{(dataobj.name == 'details' || dataobj.name == 'answer' || savetestblon) ? '关闭':'交卷'}}</div>
			</div>
			
			<div class="exchange_list examination_list" :class="{'on':exchangeblon}">
				<div class="exchangeTc">
					<div class="tits">
						学习结果
						<div class="zst"></div>
						<div class="btn" @click="exchangeblon = false"></div>
					</div>
					<div class="content">
						<div class="top">
							积分<span>+{{jifen}}</span>
						</div>
						<div class="middle">
							恭喜你已完成<span>{{dataobj.testname}}</span>学习
						</div>
						<div class="end">
							<span>答题时长</span>
							<span>{{ystime}}</span>
							<span>共<i>{{dataobj.count}}</i>题</span>
							<span>答对<i>{{answernum}}</i>题</span>
						</div>
						<div class="btncon">
							<div class="btn" @click="exchangeblon = false">关闭</div>
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
		<div class="examinationbj_bottom"></div>
	</div>
	
</template>
<script>
import {savetest,getlearnrecord,gettestdetail} from '@/api/control1'
export default {
  data(){
    return {
			height: null,
			textarea: null,
			dataobj:{},
			learnId: null,
			yyhdata:[],
			hyydata:[],
			txdata:[],
			exchangeblon: false,
			timefun: null,
			djstimenum: null,
			djstime: null,
			ystimenum: 0,
			ystime: null,
			answernum: 0,
      savetestblon: false,
      jifen:0
		};
	},
	created(){
		this.dataobj = this.$route.query;
		if(this.dataobj.name){
			this.gettestdetaillist();
		}else{
			this.datalist();
		};
	},
	methods:{
		closeFun(){
			window.close();
		},
		savetest(){
			if(this.dataobj.name == 'details' || this.dataobj.name == 'answer' || this.savetestblon){
				window.close();
				return false;
			};
			var that = this,data = that.yyhdata.concat(that.hyydata).concat(that.txdata),score = null,score1 = 0,cwuwordData = [],cwuword = null,num = 0;
			for(var i=0;i<data.length;i++){
				if(data[i].choiceg_blon){
					num+=1;
				}else{
					cwuwordData.push(data[i].word_spell);
					cwuword = cwuwordData.join(',');
				};
			};
      that.answernum = num;
      let sc = parseFloat(num/that.dataobj.count).toFixed(2)*100;
      that.jifen = this.utils.getJifenByScore(sc);
			savetest({
				userid: that.utils.storageGet("userinfo").userid,
				score: num+'/'+that.dataobj.count,
				score1: sc,
				cwuword:cwuword,
        lrid: that.learnId,
        remark:that.dataobj.testname,
        jifen:that.jifen
			}).then(res => {
				that.savetestblon = true;
				that.exchangeblon = true;
				clearInterval(that.timefun);
			});
		},
		audioFun(item){
			var that = this;
			that.$set(item, 'apply_blon', true);
			that.utils.wordAudio(item.word_spell,item);
		},
		choicetextarea(item){
			var that = this,data = item.HxWord;
			for(var i=0;i<data.length;i++){
				if(data[i].id > 0 && (item.textarea == data[i].word_spell)){
					that.$set(item, 'choiceg_blon', true);
					return false;
				};
			};
			that.$set(item, 'choiceg_blon', false);
		},
		choice(item,items){
			var that = this;
			that.$set(item, 'choiceg_id', items.gid);
			if(items.id > 0){
				that.$set(item, 'choiceg_blon', true);
			}else{
				that.$set(item, 'choiceg_blon', false);
			};
			console.log(item);
		},
		datalist(){
			var that = this;
			getlearnrecord({
				userid: that.utils.storageGet("userinfo").userid,
				type: that.dataobj.type,
				scope: that.dataobj.scope,
				diff: that.dataobj.diff,
				wordtype: that.dataobj.wordtype,
				bookid: that.dataobj.bookid,
				testname: that.dataobj.testname,
				count: that.dataobj.count
			}).then(res => {
				that.learnId = res.learnId;
				that.wordtypeFun(res.list);
				that.djstimenum = res.list.length * 30;
				that.timefun = setInterval(function(){
					that.CountDown();
				}, 1000);
			});
		},
		gettestdetaillist(){
			var that = this;
			gettestdetail({
				userid: that.utils.storageGet("userinfo").userid,
				ltid: that.dataobj.ltid,
				lrid: that.dataobj.lrid
			}).then(res => {
				that.learnId = that.dataobj.lrid;
				that.dataobj.wordtype = res.wordtype;
				that.dataobj.count = res.data.length;
				that.wordtypeFun(res.data);
				if(that.dataobj.name == 'retest'){
					that.djstimenum = res.data.length * 30;
					that.timefun = setInterval(function(){
						that.CountDown();
					}, 1000);
				};
			});
		},
		wordtypeFun(listdata){
			var that = this;
			if(that.dataobj.wordtype == 2){
				that.yyhdata = listdata;
			}else if(that.dataobj.wordtype == 4){
				that.hyydata = listdata;
			}else if(that.dataobj.wordtype == 6){
				var data = listdata,num = parseInt(that.dataobj.count/2);
				that.yyhdata = data.slice(0,num);
				that.hyydata = data.slice(num,data.length);
			}else if(that.dataobj.wordtype == 8){
				that.txdata = listdata;
			}else if(that.dataobj.wordtype == 10){
				var data = listdata,num = parseInt(that.dataobj.count/2);
				that.yyhdata = data.slice(0,num);
				that.txdata = data.slice(num,data.length);
			}else if(that.dataobj.wordtype == 12){
				var data = listdata,num = parseInt(that.dataobj.count/2);
				that.hyydata = data.slice(0,num);
				that.txdata = data.slice(num,data.length);
			}else if(that.dataobj.wordtype == 14){
				var data = listdata,num = parseInt(that.dataobj.count/3);
				that.yyhdata = data.slice(0,num);
				that.hyydata = data.slice(num,num*2);
				that.txdata = data.slice(num*2,data.length);
			};
		},
		CountDown(){
			var that = this;
			if (that.djstimenum >= 0) {
				that.djstime = that.timeNumfun(that.djstimenum);
				that.ystime = that.timeNumfun(that.ystimenum);
				--that.djstimenum;
				++that.ystimenum;
			}else{
				that.savetest();
				clearInterval(that.timefun);
			};
		},
		timeNumfun(num){
			return (Math.floor(num / 60)<10?'0'+Math.floor(num / 60):Math.floor(num / 60))+':'+(Math.floor(num % 60)<10?'0'+Math.floor(num % 60):Math.floor(num % 60))
		}
	},
	mounted(){
		var that = this;
		that.height = window.innerHeight - (300*that.utils.per());
	},
	components: {
	
	},
}
</script>
<style scoped>
	
</style>